import { Map } from "immutable";
import { setSubmitSucceeded } from "redux-form";
import { reduxForm, reset, SubmissionError } from "redux-form/immutable";

import {
  compose,
  connect
} from "seneca-common/utils/components/container-utils";
import { validatePassword } from "seneca-common/utils/functions/validation/password";
import { validateString } from "seneca-common/utils/functions/validation/validateString";

import { changePassword } from "features/user";

import { updatePasswordFormName as formName } from "../consts";

const validate = (valuesIm: any) => {
  const { newPassword, verifyPassword, currentPassword } = valuesIm.toJS();
  let errors: any = {};

  if (validateString(currentPassword)) {
    errors.currentPassword = "Please enter your current password";
  }

  if (verifyPassword !== newPassword) {
    errors.verifyPassword = "Passwords do not match";
  }

  const validateNewPassword = validatePassword(newPassword);

  if (validateNewPassword) {
    errors.newPassword = validateNewPassword;
  }

  return errors;
};

const makeForm = reduxForm({
  form: formName,
  onSubmit: async (formValues: Map<string, string>) => {
    try {
      await changePassword(
        formValues.get("currentPassword")!,
        formValues.get("newPassword")!
      );
    } catch (error: any) {
      console.log("Error updating personal info", error);
      throw new SubmissionError({
        _error:
          "Sorry, we were unable to change your password. Please check if your current password is correct and try again."
      });
    }

    return undefined;
  },
  onSubmitSuccess: (unusedParam, dispatch) => {
    dispatch(reset(formName));
    dispatch(setSubmitSucceeded(formName));
  },
  validate
});

const mapStateToProps = (state: any) => {
  const formData = state.toJS().form[formName];
  return {
    formData
  };
};

const UpdatePasswordPage = compose(connect(mapStateToProps), makeForm);

export { UpdatePasswordPage };
